import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const CreateOAuth2ApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOAuth2Application"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"author"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supportEmail"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOAuth2Application"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appName"}}},{"kind":"Argument","name":{"kind":"Name","value":"author"},"value":{"kind":"Variable","name":{"kind":"Name","value":"author"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"supportEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supportEmail"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CreateOAuth2Application","document":CreateOAuth2ApplicationDocument}} as const;
export type CreateOAuth2ApplicationMutationVariables = Types.Exact<{
  appName: Types.Scalars['String']['input'];
  author: Types.Scalars['String']['input'];
  email: Types.Scalars['String']['input'];
  supportEmail: Types.Scalars['String']['input'];
}>;


export type CreateOAuth2ApplicationMutation = (
  { __typename: 'Mutation' }
  & { createOAuth2Application?: Types.Maybe<(
    { __typename: 'OAuth2Application' }
    & Pick<Types.OAuth2Application, 'id' | 'secret'>
  )> }
);

export type CreateOAuth2ApplicationMutationFn = Apollo.MutationFunction<
  CreateOAuth2ApplicationMutation,
  CreateOAuth2ApplicationMutationVariables
>;

/**
 * __useCreateOAuth2ApplicationMutation__
 *
 * To run a mutation, you first call `useCreateOAuth2ApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOAuth2ApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOAuth2ApplicationMutation, { data, loading, error }] = useCreateOAuth2ApplicationMutation({
 *   variables: {
 *      appName: // value for 'appName'
 *      author: // value for 'author'
 *      email: // value for 'email'
 *      supportEmail: // value for 'supportEmail'
 *   },
 * });
 */
export function useCreateOAuth2ApplicationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOAuth2ApplicationMutation,
    CreateOAuth2ApplicationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOAuth2ApplicationMutation,
    CreateOAuth2ApplicationMutationVariables
  >(CreateOAuth2ApplicationDocument, options);
}
export type CreateOAuth2ApplicationMutationHookResult = ReturnType<
  typeof useCreateOAuth2ApplicationMutation
>;
export type CreateOAuth2ApplicationMutationResult =
  Apollo.MutationResult<CreateOAuth2ApplicationMutation>;
export type CreateOAuth2ApplicationMutationOptions = Apollo.BaseMutationOptions<
  CreateOAuth2ApplicationMutation,
  CreateOAuth2ApplicationMutationVariables
>;
